import React, { useEffect, useState } from "react";

import { Link } from "@quintype/components";

import "./horoscope-grid.m.css";
import { getCollection } from "../../helper/api";
import Pisces from "../../atoms/zodiac-icons/pisces";
import Aquarius from "../../atoms/zodiac-icons/aquarius";
import Taurus from "../../atoms/zodiac-icons/taurus";
import Gemini from "../../atoms/zodiac-icons/gemini";
import Cancer from "../../atoms/zodiac-icons/cancer";
import Leo from "../../atoms/zodiac-icons/leo";
import Virgo from "../../atoms/zodiac-icons/virgo";
import Libra from "../../atoms/zodiac-icons/libra";
import Scorpio from "../../atoms/zodiac-icons/scorpio";
import Sagittarius from "../../atoms/zodiac-icons/sagittarius";
import Capricorn from "../../atoms/zodiac-icons/capricorn";
import Aries from "../../atoms/zodiac-icons/aries";

const HoroscopeGrid = () => {
  const [url, setUrl] = useState("/");

  const Horoscopes = [
    {
      icon: <Aries />,
      name: "ಮೇಷ",
      link: url
    },
    {
      icon: <Taurus />,
      name: "ವೃಷಭ",
      link: url
    },
    {
      icon: <Gemini />,
      name: "ಮಿಥುನ",
      link: url
    },
    {
      icon: <Cancer />,
      name: "ಕರ್ಕ",
      link: url
    },
    {
      icon: <Leo />,
      name: "ಸಿಂಹ",
      link: url
    },
    {
      icon: <Virgo />,
      name: "ಕನ್ಯಾ",
      link: url
    },
    {
      icon: <Libra />,
      name: "ತುಲಾ",
      link: url
    },
    {
      icon: <Scorpio />,
      name: "ವೃಶ್ಚಿಕ",
      link: url
    },
    {
      icon: <Sagittarius />,
      name: "ಧನು",
      link: url
    },
    {
      icon: <Capricorn />,
      name: "ಮಕರ",
      link: url
    },
    {
      icon: <Aquarius />,
      name: "ಕುಂಭ",
      link: url
    },
    {
      icon: <Pisces />,
      name: "ಮೀನ",
      link: url
    }
  ];
  useEffect(() => {
    getCollection("daily-horoscope", 0, 1).then((response) => setUrl(response[0].url));
  }, []);

  return (
    <div styleName="wrapper">
      {Horoscopes.map((item) => (
        <Link href={item.link} styleName="item-wrapper">
          <div styleName="item-icon">{item.icon}</div>
          <span styleName="item-name">{item.name}</span>
        </Link>
      ))}
    </div>
  );
};

export default HoroscopeGrid;
